/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';

export default class FinAiAgentSalesIntegrationsRoute extends Route {}
